import React, { useEffect } from 'react';
import ButtonCancelForm from '../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../components/buttons/ButtonSaveForm';
import { FundRequestStatus } from '../../../../app/models/Fund';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';


interface Props {
    status: FundRequestStatus;
    setStatus: (status: FundRequestStatus) => void;
    errorFields?: any;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const IssueDateForm = ({ 
    status, 
    setStatus, 
    onSaved, 
    onCancel, 
    onError, 
    errorFields 
}: Props) => {
    
    if (!status) return null;

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;

        setStatus({ ...status, [name]: value });
    };

    const save = () => {
        if (onSaved) onSaved();
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-6">
                    <label className="col-form-label">Fecha</label>
                    <input
                        type="date"
                        name="issue_date"
                        className="form-control"
                        onChange={handleChange}                        
                        value={status?.issue_date || ''}
                        placeholder="Ingrese fecha de emisión"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('issue_date')}
                    </div>
                </div>
            </div>
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={save} />
                </div>
            </div>
        </>
    );
};

export default IssueDateForm;
